import React from 'react'
import clsx from 'clsx'
import Tooltip from '../Tooltip'
import MediaAvatar from '../MediaAvatar'

import { useUserAPI } from '../../../providers/UserAPIProvider'

import useStyles from './styles'

const TaskAssignee = ({ userId, index, numberOfAssignees, hideAnimation }) => {
  const { allUsers, loadUser } = useUserAPI()
  const user = allUsers[userId]

  const classes = useStyles()

  React.useEffect(() => {
    if (!user) {
      loadUser(userId)
    }
  }, [user, loadUser, userId])

  return (
    <Tooltip title={user?.name ?? ''} arrow>
      <div>
        <MediaAvatar
          user={user}
          className={clsx(
            classes.avatar,
            index > 0 ? classes.marginLeft : '',
            index === numberOfAssignees - 1 ? '' : classes.avatarBorder
          )}
          style={{
            zIndex: numberOfAssignees - index
          }}
        />
      </div>
    </Tooltip>
  )
}
export default TaskAssignee
